const Sorter = {
  date: (key) => (a, b) => new Date(a[key]) - new Date(b[key]),
  number: (key) => (a, b) => a[key] - b[key],
  string: (key) => (a, b) => a[key].localeCompare(b[key]),
};

export const tableColumn = {
  users: [
    {
      title: "Name",
      dataIndex: "name",
      sorter: Sorter.string("name"),
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: Sorter.string("email"),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: Sorter.string("phone"),
    },
    {
      title: "Joined At",
      dataIndex: "createdAt",
      render: (txt) => new Date(txt).toLocaleDateString(),
      sorter: Sorter.date("createdAt"),
    },
  ],
  albums: [
    {
      title: "Name",
      dataIndex: "name",
      sorter: Sorter.string("name"),
    },
    {
      title: "Images",
      dataIndex: "_count",
      render:(_,record)=>(record?._count?.images),
      sorter: (a, b) => (a?._count?.images || 0) - (b?._count?.images || 0),
    },
    {
      title: "Created By",
      dataIndex: "name",
      render:(_,record)=>(record?.admin?.name)
    },
    
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (txt) => new Date(txt).toLocaleDateString(),
      sorter: Sorter.date("createdAt"),
    },
  ],
    subscription: [
    {
      title: "User",
      dataIndex: "name",
      render:(_,record)=>(record?.user?.name),
      // sorter: Sorter.string("name"),
    },
    {
      title: "Plan",
      dataIndex: "sub_plan_name",
      sorter: Sorter.string("sub_plan_name")
      // render:(_,record)=>(record?.sub_plan_id)
    },
    {
      title: "Total Images",
      dataIndex: "image",
      sorter: Sorter.number("image"),
    },
    {
      title: "Total Albums",
      dataIndex: "event",
      sorter: Sorter.number("event"),
    },
    {
      title: "Total Days",
      dataIndex: "time_in_days",
      sorter: Sorter.number("time_in_days"),
    },
    
    
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (txt) => new Date(txt).toLocaleDateString(),
      sorter: Sorter.date("createdAt"),
    },
  ]
};


